<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.table && localService.languageContent.purchase_entry">
    <div class="banner freeze_height" *ngIf="batchEntryDetails">
        <div class="row">
            <div class="col-2">
                <a class="button" [routerLink]="['/batch-entries' + localService.basicParamsString,businessId]">
                    <i class="material-icons button icon_adjust">arrow_back</i>
                </a>
            </div>
            <div class="col-7">
                <app-label [Text]="localService.languageContent.table.created_on" />
                <span class="en">
                    {{batchEntryDetails.batchEntry.v8 | localDate}}
                </span>
            </div>
            <div class="col-3">
                <label style="font-weight: normal; margin-left: 30px;">
                    <input type="checkbox" [(ngModel)]="isShowInActive" (change)="onLoad()" />
                    <span class="normal_color">{{localService.languageContent.purchase_entry.show_inactive}}</span>
                </label>
            </div>
        </div>
        <div class="row" *ngIf="data">
            <div class="col-3">
                <app-label [Text]="localService.languageContent.purchase_entry.batch_id" />
                <span class="en">
                    {{batchEntryDetails.batchEntry.v2}}
                </span>
            </div>
            <div class="col-3">
                <label style="font-weight: normal;margin-left: 15px;">
                    <input type="checkbox" [(ngModel)]="isNoValidity" />
                    <span class="normal_color">{{localService.languageContent.purchase_entry.no_validity}}</span>
                </label>
            </div>
            <div class="col-3" *ngIf="!isNoValidity">
                <app-date-picker [selectedDate]="batchEntryDetails.batchEntry.v3" [isLoadTodayDate]="false"
                    (selectedDateChange)="batchEntryDetails.batchEntry.v3 = $event;" />
            </div>
            <div class="col-3" *ngIf="!isNoValidity">
                <label style="font-weight: normal;margin-left: 15px;">
                    <input type="checkbox" [(ngModel)]="isAutoDeactive" />
                    <span class="normal_color">{{localService.languageContent.purchase_entry.is_auto_deactive}}</span>
                </label>
            </div>
        </div>
        <div class="row" *ngIf="data">
            <div class="col-md-6">
                <div class="search_dd">
                    <ngx-select id="{{elementIds.product_dd}}"
                        placeholder="{{localService.languageContent.purchase_entry.select_product}}"
                        title="{{localService.languageContent.purchase_entry.select_product}}"
                        (typed)="onSearch($event)" [items]="searchItems" [optionValueField]="'key'"
                        [optionTextField]="'v3'" [allowClear]="true" (focus)="onFocusProducts()"
                        (select)="localService.onFocusNextInput(elementIds.qty, 1)" [(ngModel)]="data.v1"
                        (remove)="onRemoveProduct()">
                        <ng-template ngx-select-option-selected ngx-select-option let-option let-text="text">
                            <div class="row" title="{{option.data.v1}}">
                                <div class="col-12">
                                    <div>
                                        <span class="en">{{option.data.v5}}&nbsp;-&nbsp;</span>
                                        <span
                                            [ngClass]="localService.getLanguageCode(option.data.v2)">{{option.data.v1}}</span>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </ngx-select>
                </div>
                <div class="search_scan">
                    <app-spinner *ngIf="isShowSpinnerCount > 0"
                        style="position: absolute; margin-top: -20px;"></app-spinner>
                    <app-qr-scanner *ngIf="isShowSpinnerCount == 0" style="position: absolute; margin-top: -24px;"
                        (onQrScanned)="onQrScanned($event)"></app-qr-scanner>
                </div>
            </div>
            <div class="col-md-6" style="margin-top: 10px;">
                <div class="row">
                    <div class="col-4">
                        <input autocomplete="off" type="number" class="number"
                            (keypress)="localService.isNumberOnly($event,numericConfig)" id="{{elementIds.qty}}"
                            [(ngModel)]="data.v2" style="width:100%;"
                            placeholder="*{{localService.languageContent.purchase_entry.qty}}"
                            title="{{localService.languageContent.purchase_entry.qty}}"
                            (keydown.enter)="localService.onFocusNextInput(elementIds.add, 5,true)"
                            [disabled]="!data.v1" [ngClass]="data.v2 ? 'en' : ''" />
                    </div>
                    <div class="col-4">
                        &nbsp;
                    </div>
                    <div class="col-4">
                        <button class="btn btn-primary" style="width:100%;" (click)="onSaveBatchEntryDetail()"
                            [disabled]="!data.v1"
                            id="{{elementIds.add}}">{{localService.languageContent.common.add}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="custom_rows_body banner" *ngIf="(source && source.items.length > 0)"
        [ngStyle]="{'max-height' : maxBodyHeight + 'px'}" style="margin-top: 5px;">
        <div class="row styled_row" *ngFor="let item of source.items">
            <div class="col-md-6">
                <button class="button_icon icon_adjust"
                    title="{{item.v4 == '1' ? localService.languageContent.table.make_inactive : localService.languageContent.table.make_active}}"
                    (click)="onActiveInactiveStatus(item.key)"
                    [ngStyle]="{'color': item.v4 == '1' ? 'yellowgreen' : 'orangered' }">{{item.v4 == '1' ?
                    "toggle_on" : "toggle_off"}}</button>
                <a class="button"
                    [routerLink]="['/serial-numbers' + localService.basicParamsString, businessId, item.v1,item.key]">
                    <i class="material-icons button icon_adjust"
                        [ngStyle]="{'color' : item.v6 == '1' ? 'green' : ''}">numbers</i>
                </a>
                <span class="en">
                    {{item.v7}}&nbsp;-&nbsp;
                </span>
                <span [ngClass]="localService.getLanguageCode(item.v10)">
                    {{item.v9}}
                </span>
            </div>
            <div class="col-md-6">
                <div class="row">
                    <div class="col-6">
                        <span class="en" *ngIf="item.v5 == '1'">
                            {{localService.languageContent.purchase_entry.no_expiry}}
                        </span>
                        <span class="en" *ngIf="item.v5 == '0'">
                            {{item.v3 | date : 'dd-MMM-yyyy'}}
                        </span>
                    </div>
                    <div class="col-6 right">
                        <input autocomplete="off" type="number" class="number"
                            (keypress)="localService.isNumberOnly($event,numericConfig)"
                            id="{{elementIds.qty}}-{{item.v5}}" [(ngModel)]="item.v2" style="width:100%"
                            placeholder="*{{localService.languageContent.purchase_entry.qty}}"
                            title="{{localService.languageContent.purchase_entry.qty}}" (blur)="onAction(1, item.key)"
                            (keydown.enter)="onAction(1, item.key)" [ngClass]="item.v2 ? 'en' : ''" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-paging *ngIf="source && source.paging" [paging]="source.paging" (onPagingRefreshed)="onLoad()"></app-paging>
</div>